[
  {
    "date": "27. März 2026",
    "time": "09:00 - 17:00 Uhr",
    "location": "Remote (Zoom)",
    "spots": 8,
    "price": 490
  },
  {
    "date": "10. April 2026",
    "time": "09:00 - 17:00 Uhr",
    "location": "Remote (Zoom)",
    "spots": 10,
    "price": 490
  },
  {
    "date": "24. April 2026",
    "time": "09:00 - 17:00 Uhr",
    "location": "Remote (Zoom)",
    "spots": 9,
    "price": 590
  },
  {
    "date": "08. Mai 2026",
    "time": "09:00 - 17:00 Uhr",
    "location": "Remote (Zoom)",
    "spots": 10,
    "price": 590
  },
  {
    "date": "22. Mai 2026",
    "time": "09:00 - 17:00 Uhr",
    "location": "Remote (Zoom)",
    "spots": 10,
    "price": 590
  },
  {
    "date": "05. Juni 2026",
    "time": "09:00 - 17:00 Uhr",
    "location": "Remote (Zoom)",
    "spots": 10,
    "price": 590
  },
  {
    "date": "19. Juni 2026",
    "time": "09:00 - 17:00 Uhr",
    "location": "Remote (Zoom)",
    "spots": 10,
    "price": 590
  }
]